module.exports = __webpack_public_path__ + "static/media/exam management.a5eef6c9.svg";